exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LD6SDcZYDKHJ9m7v9DYT_{z-index:3;position:absolute;inset-inline-end:10vw}._3u6uGbLTub6nztT3dajxX5{z-index:3;position:absolute;inset-inline-start:10vw}\n", ""]);

// exports
exports.locals = {
	"skip-forward-component": "LD6SDcZYDKHJ9m7v9DYT_",
	"skipForwardComponent": "LD6SDcZYDKHJ9m7v9DYT_",
	"skip-backward-component": "_3u6uGbLTub6nztT3dajxX5",
	"skipBackwardComponent": "_3u6uGbLTub6nztT3dajxX5"
};